var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 500",
    style: {
      enableBackground: "new 0 0 300 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A7A7A7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-384.000000, -7159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone-_x5B__x23_225_x5D_",
    className: "st0",
    d: "M577,7075.8c0-13.7-11.1-24.8-24.8-24.8H403.8c-13.7,0-24.8,11.1-24.8,24.8 v346.5c0,13.7,11.1,24.8,24.8,24.8h148.5c13.7,0,24.8-11.1,24.8-24.8V7075.8z M626.5,7051v396c0,27.3-22.2,49.5-49.5,49.5H379 c-27.3,0-49.5-22.2-49.5-49.5v-396c0-27.3,22.2-49.5,49.5-49.5h198C604.3,7001.5,626.5,7023.7,626.5,7051L626.5,7051z  M503.3,7372.8c0,13.7-11.1,24.8-24.8,24.8s-24.8-11.1-24.8-24.8s11.1-24.8,24.8-24.8S503.3,7359.1,503.3,7372.8L503.3,7372.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIcon);
export default __webpack_public_path__ + "static/media/iphone_icon.367991dfed7a9aa80b60ed9d9f5f1f1e.svg";
export { ForwardRef as ReactComponent };